import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Icon          from 'app/components/common/icon';
import Modal         from 'app/components/common/modal';
import StandardInput from 'app/components/common/standard-input';
import PromptsDuck   from 'app/ducks/prompts';
import utils         from 'app/helpers/utils';

class ModalPersonalEmail extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };

    this.onClose = this.onClose.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.onClickReset = this.onClickReset.bind(this);
  }

  onClose() {
    this.props.dismiss();
  }

  onChangeEmail(event) {
    const email = event.target.value;
    this.setState({email});
  }

  onClickSubmit() {
    this.props.submit(this.state.email);
  }

  onClickReset() {
    this.props.reset();
  }

  renderForm() {
    const {email} = this.state;
    const {validations, pending, failed} = this.props;
    const isEmail = utils.isEmail(email);
    const btnDisabled = pending || !isEmail;
    const btnLabel = pending ? 'Verifying...' : 'Verify Personal Email';

    return (<>
      <StandardInput className="modal-wal-confirm-pe-input" label="Personal email address" name="email" value={email} onChange={this.onChangeEmail} validations={validations} />
      <button disabled={btnDisabled} className="btn special green modal-wal-confirm-pe-submit" onClick={this.onClickSubmit}>{btnLabel}</button>
      {failed && (
        <p className="modal-wal-confirm-error">Oops! Something went wrong.</p>
      )}
    </>);
  }

  renderSuccess() {
    return this.props.hasPersonalEmail ? (<>
      <p className="modal-wal-confirm-pe-success">You're all set!</p>
      <button className="btn blue" onClick={this.onClose}>Continue</button>      
    </>) : (<>
      <p className="modal-wal-confirm-pe-success"><Icon.Envelope /> Click the verification link in your inbox to continue.</p>
    </>);
  }

  render() {
    const {success, hasPersonalEmail} = this.props;

    return (
      <Modal onClose={this.onClose} className="modal-wal-confirm">
        <h1 className="modal-wal-confirm-heading">Almost there!</h1>
        <p className="modal-wal-confirm-desc">Please verify your personal email so your Giving Wallet stays with you long-term, even if your work email ever changes.</p>
        {success ? this.renderSuccess() : this.renderForm()}
      </Modal>
    );
  }

}

const stateToProps = (state) => ({
  validations: PromptsDuck.Slx.rpeValidations(state),
  pending: PromptsDuck.Slx.rpeSubmitPending(state),
  failed: PromptsDuck.Slx.rpeSubmitFailed(state),
  success: PromptsDuck.Slx.rpeSubmitSuccess(state),
  hasPersonalEmail: PromptsDuck.Slx.hasPersonalEmail(state),
});

const dispatchToProps = (dispatch) => ({
  submit: (email) => dispatch(PromptsDuck.Ax.submitPersonalEmail(email)),
  dismiss: () => dispatch(PromptsDuck.Ax.dismissPersonalEmail()),
  reset: () => dispatch(PromptsDuck.Ax.resetPersonalEmailForm()),
});

export default connect(stateToProps, dispatchToProps)(ModalPersonalEmail);
